<div [ngClass]="{'hide-top': (scrollingDownOnMobile | async)}" class="row overview-container">
  <div class="overview-items-container">
    <mojo-tilebar>
      <mojo-overview-items-container [items$]="tiles$"></mojo-overview-items-container>
    </mojo-tilebar>
  </div>
</div>
